<template>
  <div id="editorVisualControllerDiv">
    <div>zoom Y: <input type="number" step="0.01" :value="chartRenderStore.zoomY" @input="setZoomY" /></div>
    <div>hit pos Y: <input type="number" step="1" :value="chartRenderStore.hitPosY" @input="setHitPosY" /></div>
    <div>column width: <input type="number" step="1" :value="chartRenderStore.columnWidth" @input="setColumnWidth" />
    </div>
    <div>subdivision: 1/<input type="number" step="1" :value="chartRenderStore.subdivision" @input="setSubdivison" />
    </div>
    <div>subdivision colour magic number: <input type="number" step="1"
        :value="chartRenderStore.subdivisionColouringMagicNumber" @input="setSubdivisionColouringMagicNumber" /> </div>
    <div>reverse scroll: <input type="checkbox" :checked="chartRenderStore.reverseScroll" @input="setReverseScroll" />
      <div>editor width: <input type="number" step="5" :value="mainChartRender.stageWidth.value"
          @input="setStageWidth" />
      </div>
      <div>editor height: <input type="number" step="5" :value="mainChartRender.stageHeight.value"
          @input="setStageHeight" />
      </div>
      <div>enable waveform: <input type="checkbox"
          :checked="chartRenderStore.offlineWaveformEnabled" @input="setEnableWavweform" /> </div>
    </div>
  </div>
</template>

<script setup>
import { inject } from 'vue';
import { useChartRenderStore } from '../../stores/ChartRenderStore';

const mainChartRender = inject('mainChartRender')

const chartRenderStore = useChartRenderStore()

const setZoomY = e => {
  const res = chartRenderStore.setZoomY(e.target.valueAsNumber)
  e.target.valueAsNumber = res
}

const setHitPosY = e => {
  const res = chartRenderStore.setHitPosY(e.target.valueAsNumber)
  e.target.valueAsNumber = res
}

const setColumnWidth = e => {
  const res = chartRenderStore.setColumnWidth(e.target.valueAsNumber)
  e.target.valueAsNumber = res
}

const setSubdivison = e => {
  const res = chartRenderStore.setSubdivision(e.target.valueAsNumber)
  e.target.valueAsNumber = res
}

const setSubdivisionColouringMagicNumber = e => {
  const res = chartRenderStore.setSubdivisionColouringMagicNumber(e.target.valueAsNumber)
  e.target.valueAsNumber = res
}

const setReverseScroll = e => {
  chartRenderStore.setReverseScroll(e.target.checked)
}

const setStageWidth = e => {
  let value = e.target.valueAsNumber
  if (value <= 0 || isNaN(value)) return
  if (value > 5000) {
    value = 5000
    e.target.value = 5000
  }
  mainChartRender.stageWidth.value = value
}

const setStageHeight = e => {
  const value = e.target.valueAsNumber
  if (value <= 0 || isNaN(value)) return
  mainChartRender.stageHeight.value = value
}

const setEnableWavweform = e => {
  chartRenderStore.setOfflineWaveformEnabled(e.target.checked)
}

</script>
